interface IProps {
  color: string;
  width: number;
  height: number;
}

const ArrowRight = ({ color, width, height }: IProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_31506_2999)">
        <path
          d="M12.3333 6.48163C12.3328 6.3114 12.2963 6.1432 12.2261 5.98809C12.1558 5.83299 12.0535 5.6945 11.9258 5.58174L6.3305 0.66285C6.18596 0.544669 6.00114 0.48715 5.81498 0.502415C5.62882 0.51768 5.45586 0.604537 5.33255 0.74468C5.20925 0.884824 5.14523 1.06731 5.15399 1.25367C5.16275 1.44004 5.2436 1.61573 5.37951 1.74372L9.70251 5.54325C9.72147 5.56005 9.73487 5.5822 9.74095 5.60678C9.74702 5.63136 9.74548 5.6572 9.73653 5.68089C9.72758 5.70457 9.71163 5.72498 9.69081 5.73941C9.66999 5.75385 9.64527 5.76163 9.61993 5.76172H1.054C0.862848 5.76172 0.679522 5.83757 0.544355 5.97258C0.409188 6.10759 0.333252 6.2907 0.333252 6.48163C0.333252 6.67256 0.409188 6.85568 0.544355 6.99068C0.679522 7.12569 0.862848 7.20154 1.054 7.20154H9.61842C9.64376 7.20179 9.66843 7.20967 9.68919 7.22417C9.70996 7.23867 9.72585 7.2591 9.73478 7.28278C9.74371 7.30647 9.74527 7.33229 9.73924 7.35687C9.73321 7.38145 9.71989 7.40364 9.70101 7.42052L5.37801 11.22C5.3024 11.281 5.23993 11.3567 5.19434 11.4424C5.14876 11.5281 5.121 11.6222 5.11274 11.7189C5.10448 11.8156 5.11589 11.913 5.14629 12.0052C5.17668 12.0974 5.22543 12.1825 5.2896 12.2554C5.35377 12.3283 5.43204 12.3875 5.5197 12.4294C5.60736 12.4714 5.7026 12.4951 5.7997 12.4993C5.89679 12.5035 5.99374 12.4881 6.0847 12.4539C6.17566 12.4197 6.25876 12.3675 6.329 12.3004L11.9253 7.38152C12.0531 7.26885 12.1556 7.13039 12.2259 6.97527C12.2962 6.82015 12.3328 6.65191 12.3333 6.48163Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_31506_2999">
          <rect width="12" height="12" fill="white" transform="translate(0.333252 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ArrowRight;
